import { APP_ROUTES } from 'shared/constants/navigation';
import { NewWebstoreSetupStepForms } from 'vendor/constants/WebstoreSetupSteps';

export const PEARL_VENDOR_SIGNUP_LOADER_COLOR = '#2a8478';

const PEARL_CONNECT_PLAN_TIERS = ['planone', 'plantwo', 'planthree'];

/** Premium chosen via signup welcome trial — skipped plan/payment. */
export const isPremiumTrialSignupWebstore = (webstore) => {
    if (!webstore || webstore.SubscriptionTier !== 'premium') {
        return false;
    }
    return !PEARL_CONNECT_PLAN_TIERS.includes(webstore.SelectedPlan);
};

export const getNewSetupStepsArray = (webstore) => {
    if (isPremiumTrialSignupWebstore(webstore)) {
        return [NewWebstoreSetupStepForms.SUCCESS, NewWebstoreSetupStepForms.BUSINESS];
    }

    const selectedPlan = webstore?.SelectedPlan;
    const baseSteps = [...Object.values(NewWebstoreSetupStepForms)];
    if (selectedPlan === 'planone') {
        return baseSteps.filter((step) => step !== NewWebstoreSetupStepForms.PAYMENT);
    }
    return baseSteps;
};

export const getSetupStepDisplayCounts = (currentStepCount, totalSteps) => {
    if (totalSteps === 1) {
        return { displayCurrentStep: 1, displayTotalSteps: 1 };
    }
    return {
        displayCurrentStep: currentStepCount - 1,
        displayTotalSteps: totalSteps - 1,
    };
};

export const isPearlVendorSignupFlowPath = (pathname) => {
    if (!pathname || typeof pathname !== 'string') return false;

    if (pathname.startsWith(APP_ROUTES.vendor.webstore.newsetup)) return true;
    if (pathname === APP_ROUTES.vendorNew) return true;
    if (pathname === APP_ROUTES.vendorLogin) return true;
    if (pathname === APP_ROUTES.vendor.ensureVendor) return true;

    const authPaths = [
        APP_ROUTES.vendor.auth.signup,
        APP_ROUTES.vendor.auth.welcome,
        APP_ROUTES.vendor.auth.login,
    ];
    return authPaths.includes(pathname);
};
